import { useLayoutEffect } from 'react';
import { noop } from '../utils/noop';

/*
 * Suppress useLayoutEffect (and its warnings) when not running in a browser
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85?permalink_comment_id=4150784#gistcomment-4150784
 */
export const useClientLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : noop;
